import { getRequest, putRequest } from "./api";

export const validateToken = async (token, organizationId, accountId) => {
  try {
    var endpoint = "snippet/validate-token?";
    if (organizationId !== null && organizationId !== undefined) {
      endpoint += `organizationId=${organizationId}`;
    }
    if (accountId !== null && accountId !== undefined) {
      endpoint += `&accountId=${accountId}`;
    }

    const response = await getRequest({ endpoint, token });
    if (response.status === 401) {
      return false;
    }

    const responseJson = await response.json();
    return responseJson.isValidToken;
  } catch (error) {
    return false;
  }
};

export const updateWorkspaceEnabledStatus = async (organizationId, accountId, workspaceId, enabled, token) => {
  const endpoint = "mb/phone/enable";
  const data = {
    ucaasId: organizationId,
    mbId: accountId,
    phoneId: workspaceId,
    enable: enabled,
  };

  const response = await putRequest({ endpoint, token, data });
  return response;
};

export const getSystemFeatureFlags = async (token) => {
  const endpoint = "snippet/system-feature-flags";
  try {
    const response = await getRequest({ endpoint, token });
    return response.json();
  } catch (error) {
    return null;
  }
};
